const isGlobalSearch = (collection: string) =>
    collection == "delwp-search-global-web" ||
    collection == "building-search-global-web";

export default isGlobalSearch;
